export enum FetusModalStatus {
	Registering = 0,
	Editing = 1,
	Viewing = 2,
}
